import React from "react";
import { ProtonusContext } from "..";
import { globalDataProvider } from "../defaults/global";

export default function useDataProvider(props) {
    const context = React.useContext(ProtonusContext);
    return (props && props.dataProvider)
        || (context && context.dataProvider)
        || globalDataProvider;
}